export default "__VITE_ASSET__071dc4bd__"